export default {
  namespaced: true,
  state: {
    actual: [],
    archive: [],
    myItems: [],
    seminar: null,
  },
  actions: {
    GetList({ commit, rootGetters }, payload) {
      return rootGetters.axl.post('seminars/api/seminars/list', payload)
        .then((response) => {
          commit('setField', { name: 'actual', value: response.data.actual });
          commit('setField', { name: 'archive', value: response.data.archive });
        });
    },
    GetView({ commit, rootGetters }, payload) {
      commit('setField', { name: 'seminar', value: [] });
      return rootGetters.axl.post('seminars/api/seminars/view', payload)
        .then((response) => {
          commit('setField', { name: 'seminar', value: response.data.data });
        });
    },
    Subscribe({ rootGetters }, payload) {
      return rootGetters.axl.post('seminars/api/seminars/subscribe', payload);
    },
    Unsubscribe({ rootGetters }, payload) {
      return rootGetters.axl.post('seminars/api/seminars/unsubscribe', payload);
    },
    UpdateVisit({ commit, rootGetters }, payload) {
      commit('setField', { name: 'seminar', value: [] });
      return rootGetters.axl.post('seminars/api/seminars/update-visit', payload)
        .then((response) => {
          commit('setField', { name: 'seminar', value: response.data.data });
        });
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
  },
};
